// src/utils/dateUtils.ts

export const icelandicMonths = [
  'janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní',
  'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember'
];

export function formatDateTimeLocalized(dateString: string, locale: string): string {
  const date = new Date(dateString)

  if (locale === 'isl') {

    const day = date.getDate()
    const month = icelandicMonths[date.getMonth()]
    const year = date.getFullYear()
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')

    return `${day}. ${month} ${year}`
  }

  // Default to en-GB format
  return date.toLocaleString(locale, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).replace(',', ' ·')
}